import { HiringState } from '@/redux/hiring/hiring';

export const getCompanyFormValidation = ({ hiring }: any) => hiring.companyFormValidation;

export const getCompanyData = ({ hiring }: any) => hiring.companyData || {};

export const getSendCompanyDataOrder = ({ hiring }: any) => hiring.sendCompanyData;

export const getLeadData = ({ hiring }: HiringState) => hiring.leadData;

export const getEmailHiring = ({ hiring }: any) => hiring.emailPersist;

export const getLeadCreated = ({ hiring }: any) => hiring.leadCreated;

export const getHiringData = ({ hiring }: HiringState) => {
  const { companyData, subCompanies, leadData } = hiring;

  return {
    subCompanies: [
      {
        ...companyData,
      },
      ...subCompanies,
    ],
    leadId: leadData.leadId,
  };
};

export const hasSubCompanies = ({ hiring }: HiringState): boolean | undefined => {
  const { hasSubCompanies } = hiring;

  return hasSubCompanies;
};

export const getSubCompanies = ({ hiring }: HiringState) => {
  const { subCompanies } = hiring;

  return subCompanies;
};

export const isSubCompaniesValid = ({ hiring }: HiringState) => {
  const { isSubCompaniesValid } = hiring;

  return isSubCompaniesValid;
};

export const isSubCompaniesEntryValid = ({ hiring }: HiringState) => {
  const { isSubCompaniesEntryValid } = hiring;

  return isSubCompaniesEntryValid;
};

export const getSelectAdminValidation = ({ hiring }: any) => hiring.selectAdminValidation;

export const getAdminFormValidation = ({ hiring }: any) => hiring.adminFormValidation;

export const getAdminDefault = ({ hiring }: any) => hiring.adminDefault;

export const getAdminData = ({ hiring }: any) => hiring.admin || {};

export const getCompleteCompanyData = ({ hiring }: HiringState) => {
  const { completeCompanyData } = hiring;

  return completeCompanyData;
};

export const getIsIncorporationRange = ({ hiring }: HiringState) => {
  const { isIncorporationRange } = hiring;

  return isIncorporationRange;
};
